import React from "react";
import { Link } from "react-router-dom";
export const NotFound = () => {
    return (React.createElement("div", null,
        React.createElement("h1", null, "RECORD NOT FOUND: You have attempted to view a record that has not been found."),
        React.createElement("h2", null, "Please contact the Portal Administrators or Complaints Team if you think you should be able to view this record."),
        React.createElement("h2", null,
            React.createElement(Link, { to: "/complaints" }, "Click to go to the Complaints home page"))));
};
